import React, { useEffect, useRef, useState } from 'react';
import { MapPin, Search, X } from 'lucide-react';
import { loadGoogleMapsScript } from '../utils/googleMapsLoader';

/**
 * LocationPicker Component
 * 
 * Using the new google.maps.places.Place API as recommended by Google.
 * Implements robust initialization with fallback strategies.
 * 
 * Reference: https://developers.google.com/maps/documentation/javascript/places-migration-overview
 */

const LocationPicker = ({ 
  location, 
  latitude, 
  longitude, 
  onLocationChange, 
  onCoordinatesChange 
}) => {
  const [searchValue, setSearchValue] = useState(location || '');
  const [predictions, setPredictions] = useState([]);
  const [showPredictions, setShowPredictions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGoogleMapsReady, setIsGoogleMapsReady] = useState(false);
  const autocompleteSuggestion = useRef(null);
  const placeService = useRef(null);
  const searchTimeout = useRef(null);
  const placesServiceDiv = useRef(null);

  useEffect(() => {
    // TEMPORARILY COMMENTED OUT: Initialize Google Places services when Google Maps is loaded
    // const initializeServices = () => {
    //   console.log('initializeServices called');
    //   console.log('window.google exists:', !!window.google);
    //   console.log('window.google.maps exists:', !!window.google?.maps);
    //   console.log('window.google.maps.places exists:', !!window.google?.maps?.places);
      
    //   try {
    //     if (window.google && window.google.maps && window.google.maps.places) {
    //       // Try to use the new AutocompleteSuggestion API first
    //       if (window.google.maps.places.AutocompleteSuggestion) {
    //         try {
    //           autocompleteSuggestion.current = new window.google.maps.places.AutocompleteSuggestion();
    //         } catch (error) {
    //           console.warn('Failed to create AutocompleteSuggestion:', error);
    //           autocompleteSuggestion.current = null;
    //         }
    //       } else {
    //         // Fallback to the legacy AutocompleteService if new API is not available
    //         console.warn('AutocompleteSuggestion not available, falling back to AutocompleteService');
    //         try {
    //           autocompleteSuggestion.current = new window.google.maps.places.AutocompleteService();
    //         } catch (error) {
    //           console.warn('Failed to create AutocompleteService:', error);
    //           autocompleteSuggestion.current = null;
    //         }
    //       }
          
    //       // Use the new Place API as recommended by Google
    //       console.log('Attempting to initialize Place API...');
          
    //       // Create a more robust initialization with multiple attempts
    //       let placeApiInitialized = false;
    //       let attempts = 0;
    //       const maxAttempts = 3;
          
    //       const tryInitializePlaceAPI = () => {
    //         attempts++;
    //         console.log(`Place API initialization attempt ${attempts}/${maxAttempts}`);
            
    //         try {
    //           // Check if Place API is available and all dependencies are loaded
    //           if (window.google.maps.places.Place && 
    //               window.google.maps.places.AutocompleteSuggestion &&
    //               window.google.maps.places.Place.prototype &&
    //               window.google.maps.places.Place.prototype.getDetails) {
                
    //               console.log('Place API dependencies verified, creating instance...');
    //               placeService.current = new window.google.maps.places.Place();
                
    //               // Verify the instance was created properly
    //               if (placeService.current && typeof placeService.current.getDetails === 'function') {
    //                 console.log('Place API initialized successfully!');
    //               placeApiInitialized = true;
    //               return;
    //             }
    //           }
              
    //           throw new Error('Place API dependencies not fully loaded');
              
    //         } catch (error) {
    //           console.warn(`Place API initialization attempt ${attempts} failed:`, error);
              
    //           if (attempts < maxAttempts) {
    //             // Wait a bit longer before retrying
    //             const delay = attempts * 200; // 200ms, 400ms, 600ms
    //             console.log(`Retrying in ${delay}ms...`);
    //             setTimeout(tryInitializePlaceAPI, delay);
    //         }
    //       } else {
    //         console.error('All Place API initialization attempts failed, using fallback');
    //         // Fallback to PlacesService if all attempts fail
    //         initializePlacesServiceFallback();
    //       }
    //     }
    //   };
          
    //       const initializePlacesServiceFallback = () => {
    //         console.log('Initializing PlacesService fallback...');
    //         if (!placesServiceDiv.current) {
    //           placesServiceDiv.current = document.createElement('div');
    //           placesServiceDiv.current.id = 'places-service-container';
    //           placesServiceDiv.current.style.display = 'none';
    //           document.body.appendChild(placesServiceDiv.current);
    //         }
            
    //         try {
    //           placeService.current = new window.google.maps.places.PlacesService(
    //             placesServiceDiv.current
    //           );
    //           console.log('PlacesService fallback initialized successfully');
    //         } catch (error) {
    //           console.warn('Failed to create PlacesService fallback:', error);
    //           placeService.current = null;
    //         }
    //       };
          
    //       // Start the initialization process
    //       tryInitializePlaceAPI();
    //     } else {
    //       console.warn('Google Maps or Places API not fully loaded yet');
    //     }
    //   } catch (error) {
    //     console.error('Error initializing Google Maps services:', error);
    //     autocompleteSuggestion.current = null;
    //     placeService.current = null;
    //   }
    // };

    // TEMPORARILY COMMENTED OUT: Load Google Maps script and initialize services
    // loadGoogleMapsScript()
    //   .then(() => {
    //     console.log('Google Maps script loaded successfully');
    //     console.log('window.google:', window.google);
    //     console.log('window.google.maps:', window.google?.maps);
    //     console.log('window.google.maps.places:', window.google?.maps?.places);
        
    //     // Add a longer delay to ensure Google Maps and all dependencies are fully initialized
    //     setTimeout(() => {
    //       console.log('Initializing Google Maps services...');
    //       initializeServices();
    //       setIsGoogleMapsReady(true);
    //       console.log('Google Maps services initialized');
    //     }, 500);
    //   })
    //   .catch((error) => {
    //     console.error('Failed to load Google Maps for LocationPicker:', error);
    //   });

    // TEMPORARILY COMMENTED OUT: Cleanup function
    // return () => {
    //   // Clean up the DOM element we created
    //   if (placesServiceDiv.current && document.body.contains(placesServiceDiv.current)) {
    //     try {
    //       document.body.removeChild(placesServiceDiv.current);
    //       } catch (error) {
    //       console.warn('Error removing places service div:', error);
    //     }
    //     placesServiceDiv.current = null;
    //   }
    // };
    
    // TEMPORARILY: Set Google Maps as ready without loading Places API
    setIsGoogleMapsReady(true);
  }, []);

  useEffect(() => {
    setSearchValue(location || '');
  }, [location]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    // Don't call onLocationChange here - wait for blur event

    // Clear previous timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Clear predictions if search is empty
    if (!value.trim()) {
      setPredictions([]);
      setShowPredictions(false);
      return;
    }

    // TEMPORARILY COMMENTED OUT: Debounce search to avoid too many API calls
    // searchTimeout.current = setTimeout(() => {
    //   getPlacePredictions(value);
    // }, 300);
  };

  const handleSearchBlur = () => {
    // Only update location when user finishes typing
    if (searchValue.trim()) {
      onLocationChange(searchValue);
    } else {
      // If the field is empty, clear the location
      onLocationChange('');
      onCoordinatesChange(null, null);
    }
  };

  // TEMPORARILY COMMENTED OUT: const getPlacePredictions = async (input) => {
  //   if (!autocompleteSuggestion.current || !input.trim() || !window.google || !window.google.maps) {
  //     setPredictions([]);
  //     setShowPredictions(false);
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
      
  //     const request = {
  //       input: input.trim(),
  //       types: ['geocode', 'establishment'],
  //       componentRestrictions: { country: 'us' } // Restrict to US for now
  //   };

  //     // Handle both new and legacy APIs
  //     if (autocompleteSuggestion.current.getPlacePredictions.constructor.name === 'AsyncFunction') {
  //       // New AutocompleteSuggestion API (async)
  //       const response = await autocompleteSuggestion.current.getPlacePredictions(request);
        
  //       if (response && response.predictions) {
  //         setPredictions(response.predictions);
  //         setShowPredictions(true);
  //       } else {
  //         setPredictions([]);
  //         setShowPredictions(false);
  //       }
  //     } else {
  //       // Legacy AutocompleteService API (callback-based)
  //       autocompleteSuggestion.current.getPlacePredictions(
  //         request,
  //         (predictions, status) => {
  //           setIsLoading(false);
  //           if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
  //             setPredictions([]);
  //             setShowPredictions(true);
  //           } else {
  //             setPredictions([]);
  //             setShowPredictions(false);
  //           }
  //         }
  //       );
  //       return; // Don't set loading to false here as it's handled in callback
  //     }
      
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error('Error getting place predictions:', error);
  //     setIsLoading(false);
  //     setPredictions([]);
  //     setShowPredictions(false);
  //   }
  // };

  // TEMPORARILY COMMENTED OUT: const selectPrediction = async (prediction) => {
  //   setSearchValue(prediction.description);
  //   onLocationChange(prediction.description);
  //   setShowPredictions(false);
  //   setPredictions([]);

  //   // Get place details to extract coordinates
  //   if (placeService.current && window.google && window.google.maps) {
  //     try {
  //       // Handle both new Place API and legacy PlacesService
  //       if (placeService.current.getDetails) {
  //         // Check if it's the new Place API (async) or legacy PlacesService (callback-based)
  //         if (placeService.current.getDetails.constructor.name === 'AsyncFunction') {
  //           // New Place API (async)
  //           console.log('Using Place API for place details');
  //           try {
  //             const place = await placeService.current.getDetails({
  //               placeId: prediction.place_id,
  //               fields: ['geometry', 'formatted_address']
  //             });
              
  //             if (place && place.geometry && place.geometry.location) {
  //               const lat = place.geometry.location.lat();
  //               const lng = place.geometry.location.lng();
  //               onCoordinatesChange(lat, lng);
                
  //               // Update the location with the formatted address
  //               if (place.formatted_address) {
  //                 setSearchValue(place.formatted_address);
  //                 onLocationChange(place.formatted_address);
  //               }
  //             }
  //           } catch (error) {
  //             console.error('Error getting place details from Place API:', error);
  //             // Fallback to geocoding
  //             fallbackGeocode(prediction.description);
  //           }
  //         } else {
  //           // Legacy PlacesService API (callback-based)
  //           console.log('Using PlacesService fallback for place details');
  //           placeService.current.getDetails(
  //             {
  //               placeId: prediction.place_id,
  //               fields: ['geometry', 'formatted_address']
  //             },
  //             (place, status) => {
  //               if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
  //                 const lat = place.geometry.location.lat();
  //                 const lng = place.geometry.location.lng();
  //               onCoordinatesChange(lat, lng);
                
  //               // Update the location with the formatted address
  //               if (place.formatted_address) {
  //                 setSearchValue(place.formatted_address);
  //                 onLocationChange(place.formatted_address);
  //               }
  //             }
  //           );
  //         }
  //       } else {
  //         console.warn('Place service not properly initialized');
  //         // Fallback: try to geocode the address
  //         fallbackGeocode(prediction.description);
  //       }
  //     } catch (error) {
  //       console.error('Error getting place details:', error);
  //       // Fallback: try to geocode the address
  //       fallbackGeocode(prediction.description);
  //       }
  //   } else {
  //     console.warn('Place service not available for getting details');
  //     // Fallback: try to geocode the address
  //     fallbackGeocode(prediction.description);
  //   }
  // };

  // TEMPORARILY COMMENTED OUT: const fallbackGeocode = (address) => {
  //   if (!window.google || !window.google.maps) return;
    
  //   try {
  //     const geocoder = new window.google.maps.Geocoder();
  //     geocoder.geocode({ address }, (results, status) => {
  //       if (status === 'OK' && results[0]) {
  //         const location = results[0].geometry.location;
  //         const lat = location.lat();
  //         const lng = location.lng();
  //         onCoordinatesChange(lat, lng);
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Fallback geocoding failed:', error);
  //   }
  // };

  const clearLocation = () => {
    setSearchValue('');
    onLocationChange('');
    onCoordinatesChange(null, null);
    setPredictions([]);
    setShowPredictions(false);
  };

  // TEMPORARILY COMMENTED OUT: const openInGoogleMaps = () => {
  //   let url;
  //   if (latitude && longitude) {
  //     url = `https://www.google.com/maps?q=${latitude},${longitude}`;
  //   } else if (searchValue) {
  //     url = `https://www.google.com/maps?q=${encodeURIComponent(searchValue)}`;
  //   } else {
  //     return;
  //   }
  //   window.open(url, '_blank');
  // };

  // Show loading state while Google Maps is initializing
  if (!isGoogleMapsReady) {
    return (
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Location (Optional)
        </label>
        <div className="flex items-center space-x-3 py-2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          <span className="text-gray-500 text-sm">Initializing location services...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Location (Optional)
      </label>
      
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MapPin className="h-5 w-5 text-gray-400" />
        </div>
        
        <input
          type="text"
          id="location-input"
          value={searchValue}
          onChange={(e) => handleSearchChange(e.target.value)}
          onBlur={handleSearchBlur}
          placeholder="Enter event location or address..."
          className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        
        <div className="absolute inset-y-0 right-0 flex items-center pr-2">
          {isLoading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
          )}
          {searchValue && (
            <button
              onClick={clearLocation}
              className="p-1 text-gray-400 hover:text-gray-600"
              title="Clear location"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>

      {/* TEMPORARILY COMMENTED OUT: Autocomplete predictions */}
      {/* {showPredictions && predictions.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {predictions.map((prediction, index) => (
            <button
              key={index}
              onClick={() => selectPrediction(prediction)}
              className="w-full px-4 py-2 text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none border-b border-gray-100 last:border-b-0"
            >
              <div className="flex items-center gap-2">
                <Search className="h-4 w-4 text-gray-400" />
                <div>
                  <div className="text-sm font-medium text-gray-900">
                    {prediction.structured_formatting?.main_text || prediction.description}
                  </div>
                  {prediction.structured_formatting?.secondary_text && (
                    <div className="text-xs text-gray-500">
                      {prediction.structured_formatting.secondary_text}
                    </div>
                  )}
                </div>
              </div>
            </button>
          ))}
        </div>
      )} */}

      {/* TEMPORARILY COMMENTED OUT: Location info */}
      {/* {(latitude || longitude) && (
        <div className="mt-2 p-2 bg-blue-50 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="text-xs text-blue-700">
              <strong>Coordinates:</strong> {parseFloat(latitude || 0).toFixed(6)}, {parseFloat(longitude || 0).toFixed(6)}
            </div>
            <button
              onClick={openInGoogleMaps}
              className="text-xs text-blue-600 hover:text-blue-800 underline"
            >
              View on Map
            </button>
          </div>
        </div>
      )} */}

      {/* TEMPORARILY COMMENTED OUT: Click outside to close predictions */}
      {/* {showPredictions && (
        <div
          className="fixed inset-0 z-5"
          onClick={() => setShowPredictions(false)}
        />
      )} */}
    </div>
  );
};

export default LocationPicker; 